export default function FormulaColumnValidator(values) {
  if (!values.options.formula) {
    window.appStore.notificationStore.showNotification(
      "Please enter formula",
      "error"
    );
    return false;
  }
  if (!values.options.formula_column) {
    window.appStore.notificationStore.showNotification(
      "Please select a formula data type",
      "error"
    );
    return false;
  }
  return true;
}
